module.exports = __webpack_public_path__ + "static/media/10.fc182561.jpg";